import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_PROFILES_DETAILS } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type {
  GetProfilesDetailsPayload,
  GetProfilesDetailsResult,
} from '../../growthChart/types/getProfilesDetails.types';

export const getProfilesDetails = (builder: BuilderType) =>
  builder.query<GetProfilesDetailsResult, GetProfilesDetailsPayload>({
    query: (data) => ({
      data,
      method: 'POST',
      url: GET_PROFILES_DETAILS,
    }),
    transformResponse: (response: GenericApiResponse<GetProfilesDetailsResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
